import axios from 'axios';
import moment from 'moment';
import {
  FETCH_USER,
  FETCH_SITES,
  PAGES_RAW,
  PAGE_LOADING,
  QUERY_LOADING,
  START_DATE,
  END_DATE,
  FOCUSED_INPUT,
  QUERIES,
  QUERIES_PAGINATED,
  IS_PAGE_ACTIVE,
  FETCH_PAGE_METRICS_BY_DATE,
  SELECT_METRIC,
  SELECTED_PAGE,
  FETCH_QUERY_METRICS_BY_DATE,
  SELECTED_QUERY,
  IS_QUERY_ACTIVE,
  PAGE_COUNT,
  QUERIES_COUNT,
  POSITION_FILTER,
  ACTIVE_QUERY_PAGE_NUM,
  COUNTRY_LIST,
  SELECTED_COUNTRY,
  TITLE_TAG,
  META_DESCRIPTION,
  SELECTED_SITE,
  ERROR,
  H1,
  KEYWORD_DENSITY,
  OCCURRENCE,
  QUERIES_FIVE_W,
  TITLE_COPY,
  DESC_COPY,
  H1_COPY,
  COPY_RESET,
  TITLE_LEN,
  META_DESC_LEN,
  DEVICE,
  ACTIVE_PAGE_NUM,
  DEVICE_LIST,
  PAGE_SORT_METRIC,
  QUERY_SORT_METRIC,
  PAGE_ORDER_DIRECTION,
  QUERY_ORDER_DIRECTION,
  QUERIES_FIVE_W_TOGGLE,
  QUERIES_RAW,
  QUERIES_SORT,
  KEYWORD_VOLUME,
  DATE_PRESET,
  CHART_TOGGLE,
  ADMIN_USERS_TO_ADD,
  ADMIN_USERS_TO_REMOVE,
  EXPORT_LOADING,
  EXPORT_DATA,
  PAYMENT_CONFIRMATION,
  UNSUBSCRIBE_CONFIRMATION,
  PAGES_SEARCH
} from './types';

import { formatQueriesForFiveW, getKeywordsByPosition, stringToBoolean, getPagesBySearchQuery } from '../helpers';

export const fetchUser = () => async dispatch => {
  const res = await axios.get('/api/current_user');
  dispatch({ type: FETCH_USER, payload: res.data });
};

export const handleStripeToken = (tokenObj, interval) => async dispatch => {
  try {
    const res = await axios.post('/api/stripe', {tokenObj, interval});
    dispatch({ type: FETCH_USER, payload: res.data });
    dispatch({ type: PAYMENT_CONFIRMATION, payload: true });
  } catch(err) {
    console.log(err);
  }
};

export const fetchExportCsv = options => async dispatch => {
  dispatch({ type: EXPORT_LOADING, payload: true });

  try {
    const res = await axios.post('/api/export', options);
    dispatch({ type: EXPORT_DATA, payload: res.data });
  } catch(err) {
    console.log(err);
  }

  dispatch({ type: EXPORT_LOADING, payload: false });
}

export const resetFetchExport = () => {
  return { type: EXPORT_DATA, payload: [] };
};

export const fetchSites = () => async dispatch => {
  const res = await axios.get('/api/webmasters/sites');
  const { sitesToAdd } = res.data;

  return res.data.error ? dispatch({ type: ERROR, payload: true })
                        : dispatch({ type: FETCH_SITES, payload: sitesToAdd });
};

export const resetErrors = () => {
  return { type: ERROR, payload: false };
};

export const selectCountry = country => {
  const selectedCountry = country ? country : 'all';
  return { type: SELECTED_COUNTRY, payload: selectedCountry };
};

export const fetchPages = options => async dispatch => {
  if (!options) {
    dispatch({ type: PAGES_RAW, payload: [] });
    dispatch({ type: PAGE_COUNT, payload: 0 });
    return;
  }

  const { startDate, endDate, country, device } = options;

  dispatch({ type: PAGE_LOADING, payload: true });
  dispatch({ type: SELECTED_COUNTRY, payload: country });

  const res = await axios.post('/api/webmasters/fetch-pages', {
    startDate,
    endDate,
    country,
    device
  });

  if (res.data.error) {
    dispatch({ type: PAGE_LOADING, payload: false });
    dispatch({ type: ERROR, payload: true });
    return;
  }

  dispatch({ type: PAGE_COUNT, payload: res.data.length });
  dispatch({ type: PAGES_RAW, payload: res.data });
  dispatch({ type: PAGE_LOADING, payload: false });
};

export const setDate = (startDate, endDate) => {
  if (!startDate || !endDate) {
    const fallbackStartDate = moment().startOf('day').startOf('day').subtract(14 + 1, 'days');
    const fallbackEndDate = moment().startOf('day').startOf('day').subtract(2, 'days');

    return [
      { type: START_DATE, payload: fallbackStartDate },
      { type: END_DATE, payload: fallbackEndDate }
    ];
  }

  return [
    { type: START_DATE, payload: startDate },
    { type: END_DATE, payload: endDate }
  ];
};

export const setFocusedInput = focusedInput => {
  return { type: FOCUSED_INPUT, payload: focusedInput };
};

export const fetchDates = () => {
  const startDate = moment().startOf('day').subtract(2, 'weeks');
  const endDate = moment().startOf('day').subtract(2, 'day');

  return [
    { type: START_DATE, payload: startDate },
    { type: END_DATE, payload: endDate }
  ];
};

export const setPageOrderDirection = order => {
  const metricOrder = (order => {
    switch (order) {
      case 'DESC':
        return 'ASC';
      case 'ASC':
        return 'DESC';
      default:
        return 'DESC';
    }
  })(order);

  return { type: PAGE_ORDER_DIRECTION, payload: metricOrder };
};

export const setQueryOrderDirection = order => {
  const metricOrder = (order => {
    switch (order) {
      case 'DESC':
        return 'ASC';
      case 'ASC':
        return 'DESC';
      default:
        return 'DESC';
    }
  })(order);

  return { type: QUERY_ORDER_DIRECTION, payload: metricOrder };
};

export const setPageSortMetric = metricToSort => {
  return { type: PAGE_SORT_METRIC, payload: metricToSort };
};

export const setQuerySortMetric = metricToSort => {
  return { type: QUERY_SORT_METRIC, payload: metricToSort };
};

export const fetchQueriesPaginated = options => {
  return { type: QUERIES_PAGINATED, payload: options };
};

export const fetchQueries = options => async dispatch => {
  if (options.case === 'diffSite') {
    dispatch({ type: QUERIES_COUNT, payload: 0 });
    dispatch({ type: QUERIES, payload: [] });
    dispatch({ type: QUERY_LOADING, payload: false });
    dispatch({ type: QUERIES_PAGINATED, payload: [{
      keys: ['⬅ Select a page on the left table to begin']
    }] });
  }

  const {
    startDate,
    endDate,
    sitePage,
    pageNum,
    positionFilter,
    country,
    sort,
    device
  } = options;

  if (!sitePage) return;

  // dispatch({ type: QUERY_LOADING, payload: true });

  const res = await axios.post('/api/webmasters/fetch-queries', {
    page: sitePage,
    startDate,
    endDate,
    pageNum,
    positionFilter,
    country,
    sort,
    device
  });

  if (res.data.error) {
    return dispatch({ type: ERROR, payload: true });
  }

  dispatch({ type: QUERIES_COUNT, payload: res.data });
  dispatch({ type: QUERIES, payload: res.data });
  dispatch({ type: QUERIES_PAGINATED, payload: res.data });
  dispatch({ type: QUERY_LOADING, payload: false });
  dispatch({ type: QUERIES_RAW, payload: res.data });
};

export const updateQueryPageCount = length  => {
  return { type: QUERIES_COUNT, payload: length };
};

export const checkPageActive = sitePage => {
  return { type: IS_PAGE_ACTIVE, payload: sitePage };
};

export const checkQueryActive = queryPage  => {
  return { type: IS_QUERY_ACTIVE, payload: queryPage };
};

export const fetchPageMetricsByDate = options => async dispatch => {
  if (!options) {
    return dispatch({ type: FETCH_PAGE_METRICS_BY_DATE, payload: [] });
  }

  const { startDate, endDate, sitePage, country, device } = options;
  if (!sitePage) return;

  const res = await axios.post('/api/webmasters/fetch-page-metrics', {
    page: sitePage,
    startDate,
    endDate,
    country,
    device
  });

  if (res.data.error) {
    return dispatch({ type: ERROR, payload: true });
  }

  dispatch({ type: FETCH_PAGE_METRICS_BY_DATE, payload: res.data });
};

export const selectMetric = metric => {
  return { type: SELECT_METRIC, payload: metric };
};

export const toggleQueriesFiveW = selection => {
  return { type: QUERIES_FIVE_W_TOGGLE, payload: selection };
};

export const fetchQueriesPositionFilter = options  => {
  const { queries, positionFilter, activeQueryPageNum } = options;

  const queriesPositionFilter = getKeywordsByPosition({ queries, positionFilter});

  const payload = { queries: queriesPositionFilter, activeQueryPageNum };

  return [
    { type: QUERIES_COUNT, payload: queriesPositionFilter },
    { type: QUERIES_PAGINATED, payload },
    { type: QUERIES_RAW, payload: queriesPositionFilter }
  ];
};

export const fetchQueriesForSort = options => {
  const { queryOrderDirection, queriesRaw, querySortMetric, activeQueryPageNum } = options;
  return {
    type: QUERIES_SORT,
    payload: { queryOrderDirection, queries: queriesRaw, querySortMetric, activeQueryPageNum }
  };
};

export const fetchQueriesFiveW = options => {
  const { queries, queriesFiveWToggle, activeQueryPageNum } = options;
  const queriesFiveWFiltered = formatQueriesForFiveW({ queries, queriesFiveWToggle });

  const payload = { queries: queriesFiveWFiltered, activeQueryPageNum};

  return [
    { type: QUERIES_COUNT, payload: queriesFiveWFiltered },
    { type: QUERIES_FIVE_W, payload },
    { type: QUERIES_RAW, payload: queriesFiveWFiltered }
  ];
};

export const selectPage = sitePage => {
  return sitePage ? { type: SELECTED_PAGE, payload: sitePage } : { type: SELECTED_PAGE, payload: '' };
};

export const fetchQueryMetricsByDate = options => async dispatch => {
  if (!options) {
    return dispatch({ type: FETCH_QUERY_METRICS_BY_DATE, payload: [] });
  }

  const { startDate, endDate, queryPage, sitePage, country, device } = options;
  const res = await axios.post('/api/webmasters/fetch-query-metrics', {
    query: queryPage,
    startDate,
    endDate,
    sitePage,
    country,
    device
  });

  if (res.data.error) {
    return dispatch({ type: ERROR, payload: true });
  }

  dispatch({ type: FETCH_QUERY_METRICS_BY_DATE, payload: res.data });
};

export const selectQuery = queryPage => {
  return queryPage ? { type: SELECTED_QUERY, payload: queryPage } : { type: SELECTED_QUERY, payload: null }
};

export const getPositionFilter = positionFilter => {
  return { type: POSITION_FILTER, payload: positionFilter };
};

export const getActiveQueryPageNum = pageNum => {
  return { type: ACTIVE_QUERY_PAGE_NUM, payload: pageNum };
};

export const getActivePageNum = pageNum => {
  return { type: ACTIVE_PAGE_NUM, payload: pageNum };
};

export const fetchCountryList = options => async dispatch => {
  const { startDate, endDate, siteUrl } = options;

  const res = await axios.post('/api/webmasters/fetch-country-list', {
    startDate,
    endDate,
    siteUrl
  });

  if (res.data.error) {
    return dispatch({ type: ERROR, payload: true });
  }

  const data = res.data ? res.data : [];
  dispatch({ type: COUNTRY_LIST, payload: data });
};

export const fetchDeviceList = options => async dispatch => {
  const { startDate, endDate, siteUrl, country } = options;

  const res = await axios.post('/api/webmasters/fetch-device-list', {
    startDate,
    endDate,
    siteUrl,
    country
  });

  if (res.data.error) {
    return dispatch({ type: ERROR, payload: true });
  }

  dispatch({ type: DEVICE_LIST, payload: res.data });
};

export const fetchTitleTag = options => {
  const { input, charLen } = options;
  return [
    { type: TITLE_TAG, payload: input },
    { type: TITLE_LEN, payload: charLen }
  ];
};

export const fetchMetaDescription = options => {
  const { input, charLen } = options;
  return [
    { type: META_DESCRIPTION, payload: input },
    { type: META_DESC_LEN, payload: charLen }
  ];
};

export const fetchH1 = h1 => {
  return { type: H1, payload: h1 };
};

export const fetchPageMeta = sitePage => async dispatch => {
  if (!sitePage) {
    dispatch({ type: TITLE_TAG, payload: '' });
    dispatch({ type: TITLE_LEN, payload: 0 });

    dispatch({ type: META_DESCRIPTION, payload: '' });
    dispatch({ type: META_DESC_LEN, payload: 0 });

    dispatch({ type: H1, payload: '' });
    return;
  }

  const res = await axios.post('/api/webmasters/fetch-page-meta', { sitePage });
  const { titleTag, metaDescription, h1 } = res.data;

  dispatch({ type: TITLE_TAG, payload: titleTag });
  dispatch({ type: TITLE_LEN, payload: titleTag.length });

  dispatch({ type: META_DESCRIPTION, payload: metaDescription });
  dispatch({ type: META_DESC_LEN, payload: metaDescription.length });

  dispatch({ type: H1, payload: h1 });
};

export const selectSite = siteUrl => async dispatch => {
  const res = await axios.post('/api/webmasters/select-site', { siteUrl });

  dispatch({ type: FETCH_USER, payload: res.data.user });
  dispatch({ type: SELECTED_SITE, payload: siteUrl });
};

export const checkError = () => {
  return { type: ERROR, payload: true };
};

export const clearQueries = () => {
  return [
    { type: QUERIES_COUNT, payload: 0 },
    { type: QUERIES, payload: [] }
  ];
};

export const fetchKeywordDensity = options => async dispatch => {
  if (!options) {
    dispatch({ type: OCCURRENCE, payload: '' });
    dispatch({ type: KEYWORD_DENSITY, payload: '' });
    return;
  }

  const { sitePage, queryPage } = options;
  const res = await axios.post('/api/webmasters/fetch-keyword-density', {
    sitePage,
    queryPage
  });

  const { occurrence, keywordDensity } = res.data;

  dispatch({ type: OCCURRENCE, payload: occurrence });
  dispatch({ type: KEYWORD_DENSITY, payload: keywordDensity });
};

export const checkIfCopied = type  => {
  switch (type) {
    case 'title':
      return { type: TITLE_COPY, payload: 'Title is copied!' };
    case 'description':
      return { type: DESC_COPY, payload: 'Description is copied!' };
    case 'h1':
      return { type: H1_COPY, payload: 'H1 is copied!' };
    default:
      return { type: COPY_RESET, payload: null };
  }
};

export const selectDevice = device => {
  return { type: DEVICE, payload: device.toLowerCase() };
};

export const fetchSearchQuery = (searchQuery, pagesRaw) => {
  const pagesbySearchQuery = getPagesBySearchQuery(searchQuery, pagesRaw);

  if(!pagesbySearchQuery) {
    return [
      { type: PAGES_SEARCH, payload: pagesbySearchQuery },
      { type: PAGE_COUNT, payload: 0 }
    ]
  }

  const pagesbySearchQueryLen = pagesbySearchQuery.length;

  const pageCount = pagesbySearchQueryLen > 0 ? pagesbySearchQueryLen : pagesRaw.length;

  return [
    { type: PAGES_SEARCH, payload: pagesbySearchQuery },
    { type: PAGE_COUNT, payload: pageCount } 
  ]
};

export const fetchKeywordVolume = options => async dispatch => {
  const { queriesPaginated, country } = options;
  const keywordArr = queriesPaginated.map(obj => {
    return obj['keys'][0];
  });

  const countryCode = country.slice(0, 2);

  const res = await axios.post('/api/keyword-volume', { keywords: keywordArr, country: countryCode });
  dispatch({ type: KEYWORD_VOLUME, payload: res.data })
}

export const selectDatePreset = preset => {
  return { type: DATE_PRESET, payload: preset };
};

export const toggleChart = value => {
  const boolean = stringToBoolean(value);
  const newValue = boolean ? false : true;

  return { type: CHART_TOGGLE, payload: newValue };
};

export const unsubscribe = subscription => async dispatch => {
  const res =  await axios.post('/api/stripe/unsubscribe', { subscription });

  dispatch({ type: FETCH_USER, payload: res.data });
  dispatch({ type: UNSUBSCRIBE_CONFIRMATION, payload: true });
};

export const adminGetUsers = () => async dispatch => {
  const res = await axios.get('/api/admin/users');

  const usersToAdd = res.data.filter(user => !user.bypass);
  const usersToRemove = res.data.filter(user => user.bypass);

  dispatch({ type: ADMIN_USERS_TO_ADD, payload: usersToAdd });
  dispatch({ type: ADMIN_USERS_TO_REMOVE, payload: usersToRemove });
}

export const adminAddUser = email => async dispatch => {
  const res = await axios.post('/api/admin/users/add', { email });
  dispatch({ type: FETCH_USER, payload: res.data });

  const res2 = await axios.get('/api/admin/users');

  const usersToAdd = res2.data.filter(user => !user.bypass);
  const usersToRemove = res2.data.filter(user => user.bypass);

  dispatch({ type: ADMIN_USERS_TO_ADD, payload: usersToAdd });
  dispatch({ type: ADMIN_USERS_TO_REMOVE, payload: usersToRemove });

}

export const adminRemoveUser = email => async dispatch => {
  const res = await axios.post('/api/admin/users/remove', { email });
  dispatch({ type: FETCH_USER, payload: res.data });

  const res2 = await axios.get('/api/admin/users');

  const usersToAdd = res2.data.filter(user => !user.bypass);
  const usersToRemove = res2.data.filter(user => user.bypass);

  dispatch({ type: ADMIN_USERS_TO_ADD, payload: usersToAdd });
  dispatch({ type: ADMIN_USERS_TO_REMOVE, payload: usersToRemove });
}

export const hidePaymentConfirmation = () => {
  return { type: PAYMENT_CONFIRMATION, payload: false };
};

export const hideUnsubscribeConfirmation = () => {
  return { type: UNSUBSCRIBE_CONFIRMATION, payload: false };
};



// WEBPACK FOOTER //
// ./src/actions/index.js